export function WatchLoading() {
  return (
    <output className="flex flex-col" aria-label="Loading theater">
      <div
        className="flex min-h-0 flex-1 flex-col xl:flex-row"
        aria-hidden="true"
      >
        <div className="border-border-subtle hidden shrink-0 border-r px-4 py-3 sm:px-6 xl:block xl:w-74 2xl:w-88">
          <div className="bg-border-subtle h-3 w-24 animate-pulse rounded" />
        </div>
        <div className="flex min-w-0 flex-1 flex-col gap-1 px-4 py-1 sm:px-6">
          <div className="border-border-subtle flex shrink-0 flex-col items-center gap-0.5 border-b pb-0.5">
            <div className="bg-border-subtle h-8 w-2/3 max-w-[520px] animate-pulse rounded" />
            <div className="bg-border-subtle h-3 w-1/3 max-w-[280px] animate-pulse rounded" />
          </div>
          <div className="bg-surface-alt aspect-10/7 w-full rounded-[4px]" />
        </div>
        <div className="border-border-subtle bg-surface hidden shrink-0 border-l px-4 py-3 sm:px-6 xl:block xl:w-87">
          <div className="border-border-subtle mb-2 flex items-baseline justify-between gap-2 border-b pb-2">
            <h2 className="my-0 shrink-0">
              <span className="watch-eyebrow">Division standings</span>
            </h2>
          </div>
          <div className="bg-border-subtle h-3 w-24 animate-pulse rounded" />
        </div>
      </div>
    </output>
  );
}
